export const FETCH_DEPENDENTS_WITH_PARAMS =
  'dependents/FETCH_DEPENDENTS_WITH_PARAMS';
export const FETCH_DEPENDENT_BY_ID = 'dependents/FETCH_DEPENDENT_BY_ID';
export const PATCH_DEPENDENT_BY_ID = 'dependents/PATCH_DEPENDENT_BY_ID';
